/* eslint-disable */
import { useDispatch, useSelector } from "react-redux";
import { Users, Community } from "../../../redux/Actions";
import { useCallback, useEffect, useMemo, useState } from "react";
import Component from "Components";
import { EditOutlined, SyncOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Empty,
  Form,
  List,
  Row,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import CreateUser from "./CreateUser";
import Spinner from "Components/Spinner/Spiner";
import CommonFunctions from "utils/CommonFunction/CommonFunctions";
import { CommunityForm } from "../Communitys";
import Lists from "../../../utils/CommonList/CommonList";
import UserDirectory from "./UserDirectory/UserDirectory";
import AddBoardUser from "./UserDirectory/AddBoardVueUser";
const ViewUsers = () => {
  const { DynamicTable, Modal, SelectBox } = Component;
  const dispatch = useDispatch();
  const uDirectoryUpdate = useSelector(state=> state?.GetAllUser);
  const userid = useParams();
  const [form] = Form.useForm();
  const [directoryForm] = Form.useForm();
  const [boardForm] = Form.useForm();
  const {
    loading,
    password,
    CommunityDetails,
    usersDetails,
    genrateLoading,
    BoardFeatures,getBoardVueUsers,getCommunities
  } = useSelector((state) => state?.GetAllUser);
  let dd = useSelector((state) => state?.GetAllUser);
  const communityStatus = useSelector(state=>state?.Communitys)
  const { getAllCommunitys, getCommunityById, updateData } = useSelector(
    (state) => state?.Communitys
  );
  const [uDirectoryData,setUDirectoryData] = useState({});
   const [visible,setVisible] = useState({
      emailVisible:false,homePhoneVisible:false,listingVisible:false,cellPhoneVisible:false
    })
  const directoryColumns = [
    ...Lists.directoryColumns,

    {
      title: "Listing Visible",
      dataIndex: "listingVisible",
      render: (_, record) => (
        <>
          {record?.listingVisible  ? "Yes" : "No"}
        </>
      )
    },
  
    {
      title: "Home Phone Visible",
      dataIndex: "homePhoneVisible",
      render: (_, record) => (
        <>
          {record?.homePhoneVisible  ? "Yes" : "No"}
        </>
      )
    },
    {
      title: "Email Visible",
      dataIndex: "emailVisible",
      render: (_, record) => (
        <>
          {record?.emailVisible  ? "Yes" : "No"}
        </>
      )
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <>
          <Button  icon={
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 4.49998H4C3.46957 4.49998 2.96086 4.7107 2.58579 5.08577C2.21071 5.46084 2 5.96955 2 6.49998V20.5C2 21.0304 2.21071 21.5391 2.58579 21.9142C2.96086 22.2893 3.46957 22.5 4 22.5H18C18.5304 22.5 19.0391 22.2893 19.4142 21.9142C19.7893 21.5391 20 21.0304 20 20.5V13.5M18.5 2.99998C18.8978 2.60216 19.4374 2.37866 20 2.37866C20.5626 2.37866 21.1022 2.60216 21.5 2.99998C21.8978 3.39781 22.1213 3.93737 22.1213 4.49998C22.1213 5.06259 21.8978 5.60216 21.5 5.99998L12 15.5L8 16.5L9 12.5L18.5 2.99998Z"
                  stroke="#6D6D6D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            } onClick={() => editUserDirectoryFormHandle(record)} type="none"></Button>
        </>
      )
    }
  
  ];

  const [userDirectoryList, setUserDirectoryList] = useState([]);
  const [viewCommunityForm, setViewCommunityForm] = useState(false);
  const [edituserDirectoryForm, setEdituserDirectoryForm] = useState(false);
  const [communityData, setCommunityData] = useState({});
  const [userpermissionId, setUserPermissionId] = useState({});
  const [edit, setEdit] = useState(true);
  const [addBoardOpen, setAddBoardOpen] = useState(false);
  const [directoryPagination, setDirectoryPagination] = useState({
    current: 1,
    pageSize: 10,
    filter: "",
    total: 0,
  });
  const [communityPagination, setCommunityPagination] = useState({
    current: 1,
    pageSize: 10,
    filter: "",
    total: 0,
  });
  const [communityList, setCommunityList] = useState([]);
  const communityColumns = useMemo(
    () => [
      {
        title: "Community Name",
        dataIndex: "communityName",
        key: "communityName",
      },
      { title: "Address", dataIndex: "address", key: "address" },
      { title: "Phone", dataIndex: "phone", key: "phone" },
      { title: "Account Number", dataIndex: "residentKey", key: "residentKey" },
      {
        title: "Resident Contact",
        dataIndex: "residentContactKey",
        key: "residentContactKey",
      },
      {
        title: "Vms Resident Availability",
        dataIndex: "residentAvailability",
        key: "residentAvailability",
      },
      
      {
        title: "Status",
        dataIndex: "isActive",
        render: (value) => (value ? "Active" : "inActive"),
        key: "isActive",
      },
      {
        title: "Modified",
        dataIndex: "modified",
        render: (value) => CommonFunctions.formatDate(value),
        key: "modified",
      },
      // {
      //   title: "Permissions",
      //   dataIndex: "permission",
      //   render: (status, record) => renderPermissionActions(record),
      //   key: "permission",
      // },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (status, record) => renderActions(record),
        key: "actions",
      },
    ],
    [CommunityDetails,communityStatus]
  );
  const HandleBoardVueUserDelete =(userData) => {
    console.log(userData,"datadatadatadata")
    if (getBoardVueUsers?.length > 0) {
  let data = {
    userId: userData?.id,
    getBoardVueUsers:getBoardVueUsers,
    id:userData?.id
  }
      
      dispatch(Users.DeleteBoardVueUserByIdRequest(data));
    }
  }

  const sortedPermissions = useMemo(() => {
    return [...(Lists?.Permissions ?? [])].sort((a, b) =>
      (a?.name ?? "").localeCompare(b?.name ?? "", undefined, { sensitivity: "base" })
    );
  }, [Lists?.Permissions]);

  const boardVueUserColumns = useMemo(
    () => [
      {
        title: "Community Name",
        dataIndex: "communityName",
        key: "communityName",
      },
      // { title: "Address", dataIndex: "address", key: "address" },
      // { title: "Phone", dataIndex: "phone", key: "phone" },
      { title: "Account Number", dataIndex: "residentKey", key: "residentKey" },
      // {
      //   title: "Resident Contact",
      //   dataIndex: "residentContactKey",
      //   key: "residentContactKey",
      // },
      
      // {
      //   title: "permissions",
      //   dataIndex: "permissionsId",
      //   render: (value) => (value == 1 ? "Board Member" :value == 2 ? "Finance" :value == 3 ? "Architectural" : "All Acceess Web User" ),
      //   key: "isActive",
      // },
      {
        title: "permissions",
        dataIndex: "permissionsId",
        render: (value,record) =>       <Form
        form={form}
        initialValues={{
          ["permissionId"+record?.communityName]: value,
        }}
      >
        <SelectBox
          options={sortedPermissions}
          className="user-form-input"
          name={"permissionId"+record?.communityName}
          placeholder="Permission"
          size="md"
          hasFeedback={true}
          validateTrigger={"onChange"}
          onChange={(e) => {
            HandleOnChanges(e, record?.communityId);
          }}
        />
      </Form>,
        key: "isActive",
      },
      {
        title: "Date Created",
        dataIndex: "dateCreated",
        render: (value) => CommonFunctions.formatDate(value),
        key: "dateCreated",
      },
      {
        title: "Date Updated",
        dataIndex: "dateUpdated",
        render: (value) => CommonFunctions.formatDate(value),
        key: "dateUpdated",
      },
      // {
      //   title: "Permissions",
      //   dataIndex: "permission",
      //   render: (status, record) => renderPermissionActions(record),
      //   key: "permission",
      // },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (status, record) =>  <Button
        onClick={() => {
          HandleBoardVueUserDelete(record);
        }}
        type="text"
         loading={loading}
        icon={
          <svg
            width="20"
            height="23"
            viewBox="0 0 20 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 5.5H3M3 5.5H19M3 5.5V19.5C3 20.0304 3.21071 20.5391 3.58579 20.9142C3.96086 21.2893 4.46957 21.5 5 21.5H15C15.5304 21.5 16.0391 21.2893 16.4142 20.9142C16.7893 20.5391 17 20.0304 17 19.5V5.5M6 5.5V3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5H12C12.5304 1.5 13.0391 1.71071 13.4142 2.08579C13.7893 2.46086 14 2.96957 14 3.5V5.5M8 10.5V16.5M12 10.5V16.5"
              stroke="#FF4E4E"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
      >
       
      </Button>,
        key: "actions",
      },
    ],
    [getBoardVueUsers]
  );

  const HandleCommunityDelete =(data) => {
      if (CommunityDetails?.data?.communityUsers?.length > 0) {
        const filterData = CommunityDetails?.data?.communityUsers?.filter(
          (allData) => allData?.id !== data?.id
        );
        const filter = {
          communityUsers: filterData,
          communtiyList: CommunityDetails?.data?.communtiyList,
          userDirectory: CommunityDetails?.data?.userDirectory,
        };
        const NewFilter = {
          data: filter,
        };
        let Request = {
          request: {
            status: false,
            communityUserId: data?.id,
            userId: data?.userId,
            communityId: data?.communityId,
          },
        };
        dispatch(Users.filterCommunityCommunityByUserIdSuccess(NewFilter));
        dispatch(Community.StatusUpdateCommunityByIdRequest(Request));
      }
    }


  
  const renderActions = (record) => {
    return (
      <Row>
        <Col>
          <Button
            onClick={() => {
              viewCommunityFormHandle(record);
            }}
            type="none"
            icon={
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 4.49998H4C3.46957 4.49998 2.96086 4.7107 2.58579 5.08577C2.21071 5.46084 2 5.96955 2 6.49998V20.5C2 21.0304 2.21071 21.5391 2.58579 21.9142C2.96086 22.2893 3.46957 22.5 4 22.5H18C18.5304 22.5 19.0391 22.2893 19.4142 21.9142C19.7893 21.5391 20 21.0304 20 20.5V13.5M18.5 2.99998C18.8978 2.60216 19.4374 2.37866 20 2.37866C20.5626 2.37866 21.1022 2.60216 21.5 2.99998C21.8978 3.39781 22.1213 3.93737 22.1213 4.49998C22.1213 5.06259 21.8978 5.60216 21.5 5.99998L12 15.5L8 16.5L9 12.5L18.5 2.99998Z"
                  stroke="#6D6D6D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          >
            {" "}
          </Button>
        </Col>
        <Col>
          {" "}
          <Button
            onClick={() => {
              HandleCommunityDelete(record);
            }}
            type="text"
             loading={communityStatus?.loading}
            icon={
              <svg
                width="20"
                height="23"
                viewBox="0 0 20 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 5.5H3M3 5.5H19M3 5.5V19.5C3 20.0304 3.21071 20.5391 3.58579 20.9142C3.96086 21.2893 4.46957 21.5 5 21.5H15C15.5304 21.5 16.0391 21.2893 16.4142 20.9142C16.7893 20.5391 17 20.0304 17 19.5V5.5M6 5.5V3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5H12C12.5304 1.5 13.0391 1.71071 13.4142 2.08579C13.7893 2.46086 14 2.96957 14 3.5V5.5M8 10.5V16.5M12 10.5V16.5"
                  stroke="#FF4E4E"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          >
            {" "}
          </Button>{" "}
        </Col>
      </Row>
    );
  };



  const fetchCommunityByUserId = (id, current, pageSize, filter) => {
    const req = {
      pageNumber: current,
      pageSize: pageSize,
      filter: filter,
      userId: id,
    };
    dispatch(Users.GetCommunityByUserIdRequest({ request: req }));
  };
const fetchBoardVueUserData = (id)=>{
  const req = {
    userId: id,
  };
  dispatch(Users.GetBoardVueUserRequest({ request: req }))
}
const fetchCommunitiesUserById = (id)=>{
  const req = {
    userId: id,
  };
  dispatch(Users.GetCommunitiesUserByIdRequest({ request: req }))
}

  const fetchFetures = (id) => {
    const req = {
      userId: id,
    };
    dispatch(Users.GetBoardFeatureRequest({ request: req }));
  };
  const fetchCommunityFeaturesFetures = (id) => {
    const req = {
      filter: "",
    };
    dispatch(Users.GetAllFeatureRequest({ request: req }));
  };

  const HandleEdit = () => {
    setEdit(!edit);
  };
  const HandleAddBoardOpen = () => {
    setAddBoardOpen(true);
    fetchCommunitiesUserById(userid?.id)
    boardForm?.resetFields()
  };
  const HandleAddBoardCancel = () => {
    setAddBoardOpen(false);
  };
  const viewCommunityFormHandle = (record) => {
    setCommunityData(record);
    dispatch(Community.UpdatedCommunityByIdSuccess(record));
    setViewCommunityForm(true);
  };
  const editUserDirectoryFormHandle = (record) => {
   // setCommunityData(record);
   // dispatch(Community.UpdatedCommunityByIdSuccess(record));
   console.log(record,"record record")
   directoryForm.setFieldsValue(record)
   setVisible({
    emailVisible:record?.emailVisible,homePhoneVisible:record?.homePhoneVisible,listingVisible:record?.listingVisible,cellPhoneVisible:record?.cellPhoneVisible
  })
   setUDirectoryData(record)
    setEdituserDirectoryForm(true);
  };

  const viewCommunityFormHandleCancel = () => {
    setViewCommunityForm(false);
  };
  const editUserDirectoryFormHandleCancel = () => {
    setEdituserDirectoryForm(false);
  };

  const HandleOnChange = (e) => {
    const { value, id } = e?.target;
    const req = {
      communityId: value,
      userId: userid?.id,
    };

    dispatch(Community.GetCommunityByIdRequest({ request: req }));
  };

  const HandleOnChanges = (e, communityId) => {
    const { value, id } = e?.target;
    const req = {
      communityId: communityId,
      userId: userid?.id,
      permissionId: value,
    };
    const request = {
      request: req,
      handle: handleResPermission,
    };
    dispatch(Community.PermissionUpdateCommunityByIdRequest(request));
  };

  const handleResPermission = () => {
    // fetchCommunityByUserId(
    //   userid?.id,
    //   communityPagination.current,
    //   communityPagination.pageSize
    // );
  };

  const handleCommunityUpdateSuccess = () => {
    // Refresh the community list after successful update
    fetchCommunityByUserId(
      userid?.id,
      communityPagination.current,
      communityPagination.pageSize
    );
    viewCommunityFormHandleCancel();
  };

  const HandleCommunityForm = () => {
    return (
      <>
        <CommunityForm
          onCancel={viewCommunityFormHandleCancel}
          users={communityData}
          HandleOnChange={HandleOnChange}
          community={getAllCommunitys?.data}
          isEdit={true}
          disabled={true}
          onUpdateSuccess={handleCommunityUpdateSuccess}
        />
      </>
    );
  };

  // const expandedRowRender = (record) => (
  //   <List
  //     bordered
  //     dataSource={record.permissions || []}
  //     renderItem={(item) => <List.Item>{item}</List.Item>}
  //     header={<b>Features</b>}
  //     locale={{ emptyText: <Empty /> }}
  //     style={{ margin: "0 16px" }}
  //   />
  // );
  const UpdateResHandle = ()=>{
    setEdituserDirectoryForm(false)
    fetchCommunityByUserId( userid?.id)
  }
  const GenratePass = () => {
    let request = {
      userId: userid?.id,
    };
    dispatch(Users.UserRegenratePasswordRequest({ request: request}));
  };
const UpdateDirectory = (values)=>{

//values.VMSresidentContactKey = uDirectoryData?.vmSresidentContactKey;
const updatedValues = {
  ...values,
  VMSresidentContactKey: uDirectoryData?.vmSresidentContactKey,
  emailVisible: visible.emailVisible,
  homePhoneVisible: visible.homePhoneVisible,
  listingVisible: visible.listingVisible,
  cellPhoneVisible:visible.cellPhoneVisible
};
dispatch(Users?.UserDirectoryUpdateRequest({request:updatedValues,handle:UpdateResHandle }))
  }
const AddBoardResHandle = ()=>{
  setAddBoardOpen(false)
  
}
useEffect(()=>{
  console.log(getBoardVueUsers,"getBoardVueUsers?.data")
  if(getBoardVueUsers?.length > 0){
    AddBoardResHandle()
  }
},[getBoardVueUsers])
  const HandleSubmitBoard= (values)=>{

    
    const updatedValues = {
      ...values,
      userId:    userid?.id,
    };
    dispatch(Users?.AddBoardVueUserByIdRequest({request:updatedValues,handle:AddBoardResHandle }))
      }
      const HandleChangeBoard= (values)=>{

      }
  useEffect(() => {
    if (getCommunityById.data) {
      dispatch(Community.UpdatedCommunityByIdSuccess(getCommunityById.data));
      setCommunityData(getCommunityById.data);
    }
  }, [getCommunityById]);

  useEffect(() => {
    fetchCommunityByUserId(
      userid?.id,
      communityPagination.current,
      communityPagination.pageSize
    );
    fetchBoardVueUserData( userid?.id)
  
    fetchFetures(userid?.id);
    fetchCommunityFeaturesFetures();
    let request = {
      userId: userid?.id,
    };
    dispatch(Users.GetUserByIdRequest(request));
  }, [userid?.id]);

  useEffect(() => {
    if (CommunityDetails?.data?.communityUsers?.length > 0) {
      setCommunityList(CommunityDetails?.data?.communityUsers);
      setCommunityPagination({
        ...communityPagination,
        total: CommunityDetails?.data?.communityUserTotalRecords,
      });
    } else {
      setCommunityList([]);
    }

    if (CommunityDetails?.data?.userDirectory?.length > 0) {
      setUserDirectoryList(CommunityDetails?.data?.userDirectory);
      setDirectoryPagination({
        ...directoryPagination,
        total: CommunityDetails?.data?.userDirectoryTotalRecords,
      });
    } else {
      setUserDirectoryList([]);
    }
  }, [CommunityDetails]);

  // Removed the useEffect that was updating community list based on updateData
  // Now we fetch fresh data from API after successful update
  useEffect(() => {
    dispatch(Community.GetAllCommunitysRequest());
  }, []);

  useEffect(() => {
    // if (usersDetails?.data?.permissionId) {
      setUserPermissionId((prevState) => ({
        ...prevState,
        permissionId: usersDetails?.data?.isActive,
      }));
    // }
  }, [usersDetails]);
  const handleVisible = (name, event) => {
    const value = event.target.value;
    setVisible(prevVisible => ({
      ...prevVisible,
      [name]: value
    }));
  };

  return (
    <>
      {loading && <Spinner />}
      <Row gutter={[12, 50]}>
        <Col sm={24}>
          <Card
            title="User Information"
            extra={
              <>
                {password?.data && userid?.id === password?.userId && (
                  <Button>
                    <Typography.Text copyable>{password?.data}</Typography.Text>
                  </Button>
                )}
                <Tooltip placement="topLeft" title={"Regenerate password"}>
                  <Button
                    className="edit-button"
                    onClick={GenratePass}
                    icon={<SyncOutlined spin={genrateLoading} />}
                  >
                    Regenerate Password{" "}
                  </Button>
                </Tooltip>{" "}
    
                <Switch
                  className="edit-button"
                  checked={userpermissionId?.permissionId}
                  disabled={true}
                  checkedChildren="User Active"
                  unCheckedChildren="User Inactive"
                />
                <Button
                  className="edit-button"
                  icon={edit ? <EditOutlined /> : ""}
                  onClick={HandleEdit}
                >
                  {!edit ? "Cancel" : ""}
                </Button>
              </>
            }
          >
            <CreateUser
              users={usersDetails?.data}
              communityList={communityList}
              getAllCommunitys={communityList}
              isEdit={true}
              disabled={edit}
            />
          </Card>
        </Col>
        <Col sm={24}>
          <Card title="Board Vue Users"  extra={
              <>
                <Button
                  onClick={HandleAddBoardOpen}
                >
                  Add New 
                </Button>
              </>
            }>
            <DynamicTable
              columns={boardVueUserColumns}
              pagination={false}
              rowKey="id"
              data={getBoardVueUsers ?? []}
              scroll={{ x: 600, y: 300 }}
            />
          </Card>
        </Col>
        <Col sm={24}>
          <Card title="Community">
            <DynamicTable
              columns={communityColumns}
              pagination={false}
              // expandable={{
              //   expandedRowRender,
              //   defaultExpandedRowKeys: ["0"],
              // }}
              rowKey="id"
              data={communityList ?? []}
              scroll={{ x: 600, y: 300 }}
            />
          </Card>
        </Col>

        <Col sm={24}>
          <Card title="User Directory">
            <DynamicTable
              data={userDirectoryList ?? []}
              columns={directoryColumns}
              pagination={false}
              scroll={{ x: 600, y: 300 }}
            />
          </Card>
        </Col>
      </Row>
      <Modal
        title="Edit Community"
        centered="center"
        open={viewCommunityForm}
        Ok={viewCommunityFormHandleCancel}
        Cancel={viewCommunityFormHandleCancel}
        width={800}
        bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
        loading={loading}
        children={HandleCommunityForm}
      />
       <Modal
        title="Edit user directory"
        centered="center"
        open={edituserDirectoryForm}
        Ok={editUserDirectoryFormHandleCancel}
        Cancel={editUserDirectoryFormHandleCancel}
        width={800}
        bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
        //loading={true}
      
        children={()=><UserDirectory onChange={handleVisible} visible={visible} setVisible={setVisible} uDirectoryUpdate={uDirectoryUpdate} UpdateDirectory={UpdateDirectory} form={directoryForm} />}
      />
       <Modal
        title="Add New"
        centered="center"
        open={addBoardOpen}
        Ok={HandleAddBoardCancel}
        Cancel={HandleAddBoardCancel}
        width={800}
        bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
        //loading={true}
      
        children={()=><AddBoardUser loading={loading} onChange={HandleChangeBoard} onFinsish={HandleSubmitBoard} form={boardForm} getCommunities={getCommunities?.data}/>}
      />
    </>
  );
};

export default ViewUsers;
